import React, { Component, Fragment } from 'react';

import { MContext } from '../../common/HelpProvider';

export default class ProductDetailsHelp extends Component {

    constructor(props) {
        super(props);
    }

    static get FocusType() {
        return {
            NONE: null,
            TITLE: 'title',
            TAGLINE: 'tagline',
            PRICING: 'pricing',
            PRODUCTTYPE: 'producttype',
            RETURNS: 'returns',
            DESCRIPTION: 'desc',
            SIZEVARIANTS: 'sizevariants',
            SIZING: 'sizing',
            DELIVERY: 'delivery',
            DELIVERYSHORT: 'deliveryshort',
            GALLERY: 'gallery',
            STORY: 'story',
        };
    }

    renderInitalPageHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product</h5>
                </div>
            </Fragment>
        );
    }

    renderTitleHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product</h5>
                </div>
            </Fragment>
        );
    }

    renderTaglineHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Tagline</h5>
                </div>
            </Fragment>
        );
    }

    renderPricingHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Pricing</h5>
                </div>
            </Fragment>
        );
    }

    renderProductTypeHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Type</h5>
                </div>
            </Fragment>
        );
    }

    renderReturnsHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Return Policy</h5>
                </div>
            </Fragment>
        );
    }

    renderDescHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Description</h5>
                </div>
            </Fragment>
        );
    }

    renderGalleryHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Gallery</h5>
                </div>
            </Fragment>
        );
    }

    renderSizeVariantsHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Size variants</h5>
                </div>
            </Fragment>
        );
    }
    renderSizingInformationHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Sizing information</h5>
                </div>
            </Fragment>
        );
    }
    renderDeliveryHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Washing Instruction</h5>
                </div>
            </Fragment>
        );
    }

    renderDeliveryShortHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Washing Instruction</h5>
                </div>
            </Fragment>
        );
    }

    renderStoryHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Story</h5>
                </div>
            </Fragment>
        );
    }

    render() {
        const { focus } = this.props;
        return (
            <div className="sticky-top pt-5">
                <MContext.Consumer>
                    {(context) => (
                        <div>
                            {context.state.help === ProductDetailsHelp.FocusType.NONE &&
                                this.renderInitalPageHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.TITLE &&
                                this.renderTitleHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.PRICING &&
                                this.renderPricingHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.PRODUCTTYPE &&
                                this.renderProductTypeHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.RETURNS &&
                                this.renderReturnsHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.TAGLINE &&
                                this.renderTaglineHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.DESCRIPTION &&
                                this.renderDescHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.SIZEVARIANTS &&
                                this.renderSizeVariantsHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.SIZING &&
                                this.renderSizingInformationHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.DELIVERYSHORT &&
                                this.renderDeliveryShortHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.DELIVERY &&
                                this.renderDeliveryHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.GALLERY &&
                                this.renderGalleryHelp()
                            }
                            {context.state.help === ProductDetailsHelp.FocusType.STORY &&
                                this.renderStoryHelp()
                            }
                        </div>
                    )}
                </MContext.Consumer>
            </div>
        );
    }
}
